import React from "react";
import {
  IconBox,
  PriceBox,
  NameBox,
  AnchorLink,
} from "../../../../components/molecules";
import { Title } from "../../../../components/atoms";
import viewIcon from "../../../../assets/images/view-icon.svg";
import acceptIcon from "../../../../assets/images/accept-icon.svg";
import printIconDark from "../../../../assets/images/print-icon-dark.svg";
import cancelFedexIcon from "../../../../assets/images/cancelFedex.png";
import pendingButton from "../../../../assets/images/Pending.png";
import { useMediaQuery } from "react-responsive";
import { calculateThreeHourRange, calculateFiveHourRange } from "./TimeHelpers";
// import {
//   convertTo12HourFormat,
//   addOrRemoveHours,
//   roundToNearestHourWithAMPM,
//   convertDateToRelativeFormat,
//   convertDateFormat,
//   adjustToWorkingHours,
// } from "./TimeHelpers";

function convertTo12HourFormat(time24) {
  // Parse the input time in 24-hour format
  const [hours, minutes] = time24.split(":");
  const hours12 = hours % 12 || 12;
  const period = hours < 12 ? "AM" : "PM";
  const time12 = `${hours12}:${minutes} ${period}`;

  return time12;
}

function addOrRemoveHours(time, hoursToAddOrRemove) {
  const [hours, minutes] = time.split(":");

  // Convert time to minutes
  let totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
  totalMinutes += hoursToAddOrRemove * 60;
  totalMinutes = (totalMinutes + 24 * 60) % (24 * 60);
  const newHours = Math.floor(totalMinutes / 60);
  const newMinutes = totalMinutes % 60;
  const formattedTime = `${String(newHours).padStart(2, "0")}:${String(
    newMinutes
  ).padStart(2, "0")}`;

  return formattedTime;
}

function roundToNearestHourWithAMPM(time) {
  const [timePart, ampm] = time.split(" ");
  const [hours, minutes] = timePart.split(":");

  // Convert the time to minutes
  const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);

  // Calculate the rounded time in minutes
  const roundedMinutes = Math.round(totalMinutes / 60) * 60;

  // Calculate the new hours
  const newHours = Math.floor(roundedMinutes / 60) % 12 || 12; // Ensure 12-hour format

  // Determine the new AM/PM
  const newAMPM = roundedMinutes < 720 ? "pm" : "am";

  // Format the result
  const formattedTime = `${newHours}${newAMPM}`;

  return formattedTime;
}

function convertDateToRelativeFormat(dateString) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const tomorrowDate = new Date();
  tomorrowDate.setDate(currentDate.getDate() + 1);

  // Check if the input date is today
  if (inputDate.toDateString() === currentDate.toDateString()) {
    return "Today";
  }

  // Check if the input date is tomorrow
  if (inputDate.toDateString() === tomorrowDate.toDateString()) {
    return "Tomorrow";
  }

  // If not today or tomorrow, return the day of the week
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const dayOfWeek = daysOfWeek[inputDate.getDay()];

  return dayOfWeek;
}

export const OrderShipmentItem = ({
  customerName,
  orderValue,
  orderDate,
  viewOnClick,
  onDispatchClick,
  orderRef,
  collectedOn,
  collectTime,
  collectedDate,
  productUrl,
  printOnClick,
  cancelFedexOnClick,
  merchantStartTime,
  merchantCloseTime
}) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });

  return (
    <>
      <div>
        <div className="order-row d-flex gap-3 w-100 justify-content-between align-items-start pt-5">
          <div className="d-flex flex-column flex-sm-row gap-2">
            <PriceBox topText={"Order Ref"} bottomText={orderRef} />
            <NameBox name={customerName} heading="Customer Name" />
            {isTabletOrMobile && (
              <PriceBox
                topText={"Est. Pickup"}
                bottomText={
                  calculateFiveHourRange(collectedDate, collectTime, merchantStartTime, merchantCloseTime)  +
                    ` (${convertDateToRelativeFormat(collectedDate)})` || "N/A"
                }
              />
            )}
          </div>
          <div className="d-flex flex-column flex-sm-row gap-2">
            <PriceBox
              topText={"Order Value"}
              bottomText={`\u00A3${orderValue}`}
            />
            <PriceBox topText={"Order Date"} bottomText={orderDate} />
          </div>
          {!isTabletOrMobile && (
            <div className="d-flex flex-column flex-sm-row gap-2">
              <PriceBox
                topText={"Estimated Pickup"}
                bottomText={ <div style={{ textAlign: "center" }}>
                  {calculateFiveHourRange(collectedDate, collectTime, merchantStartTime, merchantCloseTime)} <br />
                  ({convertDateToRelativeFormat(collectedDate)})
                </div>
                || "N/A"
                }
              />
            </div>
          )}

          <div className="d-flex flex-md-row flex-column">
            <IconBox
              style={{ maxHeight: "70px" }}
              icon={viewIcon}
              subtitle="View"
              onClick={viewOnClick}
            />
            {/* <IconBox
              icon={cancelFedexIcon}
              subtitle="Cancel FedEx"
              onClick={cancelFedexOnClick}
            /> */}
            <IconBox
              style={{ maxHeight: "70px" }}
              icon={printIconDark}
              subtitle="Print label"
              onClick={printOnClick}
            />
            {/* <IconBox
              style={{ maxHeight: "70px" }}
              icon={pendingButton}
              subtitle="Pending Dispatch"
              //onClick={onDispatchClick}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};
